import { css } from '@emotion/core'
import { measures } from 'styles/variables'

const { unit } = measures

export const logo = css`
  width: ${6 * unit}px;
`

export const logoPlaceholder = css`
  width: ${6 * unit}px;
  height: ${6 * unit}px;
  border-radius: 50%;
  background-color: #f0f0f0;
`

export const container = css`
  display: flex;

  align-items: center;

  justify-content: center;
`
